/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import moment from 'moment';

export interface IDigitalClockPluginMethods extends IPluginMethodMap {
  getTime(args?: any): Promise<{ time: string }>;
}

export class DigitalClockPlugin implements IAgentPlugin {
  readonly methods: IDigitalClockPluginMethods;

  constructor() {
    this.methods = {
      getTime: this.getTime.bind(this),
    };
  }

  async getTime(args?: any) {
    return {
      time: moment().format('HH:mm:ss'),
    };
  }
}
